export const customizeProducts = [
  {
    name: 'Cocofloss',
    description: 'Cara Cara Orange Floss',
    image: `${process.env.REACT_APP_STATIC_MEDIA}/images/customize-product-1.jpg`,
    customizeCampaign: 'Spring ’21 Customization Option',
  },
  {
    name: 'Grown Alchemist',
    description: 'Body Cream',
    image: `${process.env.REACT_APP_STATIC_MEDIA}/images/customize-product-2.jpg`,
    customizeCampaign: 'Spring ’21 Customization Option',
  },
  {
    name: 'Lark & Ives',
    description: 'Hair Scarf Bundle',
    image: `${process.env.REACT_APP_STATIC_MEDIA}/images/customize-product-3.jpg`,
    customizeCampaign: 'Fall ’21 Customization Option',
  },
  {
    name: 'Camp Collection',
    description: 'Dip Dye Market Tote',
    image: `${process.env.REACT_APP_STATIC_MEDIA}/images/customize-product-4.jpg`,
    customizeCampaign: 'Fall ’21 Customization Option',
  },
];
